import { Text } from '@interco/inter-ui/components/Text'

import * as S from './style'

type Content = {
  title: string
  description: string
}

const ContentText: Content[] = [
  {
    title: 'Dados cadastrais',
    description: `Nome completo e social, endereço completo, CPF, passaporte, telefone, e-mail, documento de identificação, filiação, documento de identificação, data de nascimento, sexo, nacionalidade, residência brasileira, documento estrangeiro.`,
  },
  {
    title: 'Informações complementares',
    description: `Renda, profissão, patrimônio, informações de cônjugue, produtos contratados, representantes, informações do empregador de conta salário e portabilidade.`,
  },
]

export const Register = () => (
  <S.Container>
    <Text variant="body-2" style={{ fontSize: 16 }}>
      Estes serão os dados compartilhados:
    </Text>
    {ContentText.map((content) => (
      <S.Content key={content.title}>
        <Text variant="body-1" bold colorWeight={500}>
          {content.title}
        </Text>
        <Text variant="body-2">{content.description}</Text>
      </S.Content>
    ))}
  </S.Container>
)
